module.exports = __webpack_public_path__ + "static/media/dennise_williams.30f0a9de.pdf";